<template>
  <div class="group relative flex flex-col">
    <label
      :for="name"
      class="text-xs uppercase text-gray-300"
      >{{ label }}{{ required ? '*' : '' }}</label
    >
    <input
      :id="name"
      :label="label"
      :name="name"
      type="file"
      :required="required"
      :placeholder="placeholder"
      class="mt-1.5 h-14 rounded-full border-2 border-gray-200 bg-white px-6 py-3 text-gray-500"
      :class="error ? 'border-red-400' : ''"
      @input="onChange" />

    <span class="absolute bottom-0 -mb-5 text-xs text-red-400">{{ error }}</span>

    <div
      class="pointer-events-none absolute bottom-0 z-20 m-1 flex w-[95%] items-center rounded-full bg-white text-gray-500">
      <div
        class="mr-2.5 flex-shrink-0 rounded-full bg-gray-300 bg-opacity-50 px-4 py-3 text-white transition focus:outline-none group-hover:bg-gray-400 lg:px-8">
        Choose file
      </div>

      <span
        class="mr-auto truncate"
        :class="value ? 'text-gray-600' : 'text-sm text-gray-250'"
        >{{ value ? value[0].name : placeholder }}</span
      >
      <IconCloseCircleLine
        v-if="value"
        class="pointer-events-auto ml-2.5 h-5 w-5 flex-shrink-0 cursor-pointer"
        @click="emit('update:modelValue', null)" />
    </div>
  </div>
</template>

<script setup lang="ts">
  type inputProps = {
    label: string
    type: string
    name: string
    value: FileList | null
    placeholder: string
    required?: boolean
    error?: string
  }

  defineProps<inputProps>()

  const emit = defineEmits<{
    (event: 'update:modelValue', payload: FileList): void
  }>()

  const onChange = (e: Event) => {
    emit(
      'update:modelValue',
      (e.target as HTMLInputElement).files && (e.target as HTMLInputElement).files.length > 0
        ? (e.target as HTMLInputElement).files
        : null
    )
  }
</script>

<style>
  input::placeholder {
    @apply text-sm text-gray-250;
  }
</style>
